import { DescriptorData } from 'app/model/crowd/descriptor-data';
import { RestfulApiService } from 'app/services/restful-api.service';
import { ModelPrepped, ModelWithoutId } from 'app/type';

class CrowdDescriptorService extends RestfulApiService<DescriptorData> {
    protected getFormName(): string {
        return 'descriptor_data';
    }

    protected getPath(): string {
        return 'crowd/descriptors';
    }

    protected getEmptyModelDefaults(): ModelWithoutId<DescriptorData> {
        return {
            descriptor: '',
            merchant: '',
            notes: '',
            status: 0,
        };
    }

    protected prepareSaveData(entity: ModelWithoutId<DescriptorData>): ModelPrepped<DescriptorData> {
        return {
            ...entity,
            dateCreated: undefined,
            userCreated: undefined,
            dateEdited: undefined,
            userEdited: undefined,
        };
    }
}

export const crowdDescriptorService = new CrowdDescriptorService();
